module.exports = __webpack_public_path__ + "img/image18.47bb1575.svg";